module.exports = __webpack_public_path__ + "img/ico-hide.51286432.svg";